import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@doger/ui/components/ui/button';

import styles from './language-switcher.module.scss';

type LanguageSwitcherProps = {
  onLanguageChange?: (language: string) => void;
};

export const LanguageSwitcher = memo(
  ({ onLanguageChange }: LanguageSwitcherProps) => {
    const { i18n, t } = useTranslation('core');

    const toggleLanguage = () => {
      const newLang = i18n.language === 'en' ? 'uk' : 'en';
      i18n.changeLanguage(newLang);
      onLanguageChange?.(newLang);
    };

    return (
      <div>
        <IconButton
          className={styles.languageSwitcher}
          variant='text'
          size='sm'
          onClick={toggleLanguage}
          title={
            i18n.language === 'en'
              ? t('language.switchToUkrainian', { lng: 'uk' })
              : t('language.switchToEnglish', { lng: 'en' })
          }
        >
          <span className={styles.languageCode}>
            {i18n.language === 'en' ? 'EN' : 'UK'}
          </span>
        </IconButton>
      </div>
    );
  }
);

LanguageSwitcher.displayName = 'LanguageSwitcher';
